import moment from 'moment';

export const isAfternoon = () => {
  const timeDis = moment().startOf('day').valueOf() + 13 * 60 * 60 * 1000 - moment().valueOf();
  return timeDis < 0;
};

export const getInitTime = () => {
  return !isAfternoon()
    ? [moment('00:00', 'HH:mm'), moment('12:59', 'HH:mm')]
    : [moment('13:00', 'HH:mm'), moment('23:59', 'HH:mm')];
};
